import { render, staticRenderFns } from "./Spec.vue?vue&type=template&id=d0c31bb6&scoped=true&"
import script from "./Spec.vue?vue&type=script&lang=js&"
export * from "./Spec.vue?vue&type=script&lang=js&"
import style0 from "./Spec.vue?vue&type=style&index=0&id=d0c31bb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c31bb6",
  null
  
)

export default component.exports